import { render, staticRenderFns } from "./RecallDialog.vue?vue&type=template&id=05b19c95"
import script from "./RecallDialog.vue?vue&type=script&lang=js"
export * from "./RecallDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports